import React, {useState, useEffect, useContext} from "react";
import { getReproductions, getReproductionsByUser } from "../../../api/reproductionApi";
import CroissanceWheel from "./adminCroissanceWheel";
import { changeReproductionStatus, changeReproductionStatusE } from "../../../api/reproductionApi";
import { AuthContext } from "../../../Contexts/AuthContext";

export const AdminCroissance = () => {
  const { user } = useContext(AuthContext);
  const [reproductions, setReproductions] = useState([]);
  const isEleveur = user?.role === 'eleveur';

  useEffect(() => {
    loadReproductions();
  }, [isEleveur, user?.id]);

  const loadReproductions = () => {
    const request = isEleveur ? getReproductionsByUser(user.id) : getReproductions();
    request.then(data => setReproductions(data));
  };

  const handleStatusChange = async (id, newStatus) => {
  try {
    if (isEleveur) {
      await changeReproductionStatusE(id, newStatus);
    } else {
      await changeReproductionStatus(id, newStatus);
    }

    const fresh = isEleveur ? await getReproductionsByUser(user.id) : await getReproductions();
    setReproductions(fresh);

  } catch (err) {
    console.error("Status change failed:", err);
    throw err;
  }
};

  return (
    <div>
      <CroissanceWheel reproductions={reproductions} onStatusChange={handleStatusChange} />
    </div>
  );
};